// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";

import moment from 'moment';
import MetaInfo from 'vue-meta-info';

import storage from "./common/storage.js";
import http from "./models/http.js";
import store from "./vuex/store.js";
import '@/vendors/rem.js';

import configs from "./configs/configs";


import "@/assets/styles/main.scss";
import "@/assets/styles/style.css";
import "@/assets/styles/common.css";
import "@/assets/fonts/font.css";
import VueAwesomeSwiper from "vue-awesome-swiper";

import { Toast, Swipe, SwipeItem, Field, Tab, Tabs, Collapse, CollapseItem, List, Loading } from 'vant';


Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.prototype.$http = http;
Vue.use(VueAwesomeSwiper);
Vue.use(MetaInfo);
Vue.use(Toast).use(Swipe).use(SwipeItem).use(Field).use(Tab).use(Tabs).use(Collapse).use(CollapseItem).use(List).use(Loading);

Vue.mixin({
    data() {
        return {
            uploadUrl:configs.baseURL
        };
    },
    computed: {
        header() {
            let token = storage.getToken() || "";
            return {
                Authorization: "bearer " + token
            };
        },
    }
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router: router,
    template: "<App/>",
    store,
    components: {
        App
    }
});



// WEBPACK FOOTER //
// ./src/main.js